import { render, staticRenderFns } from "./ArtisanMsgBox.vue?vue&type=template&id=17c6da22"
import script from "./ArtisanMsgBox.vue?vue&type=script&lang=js"
export * from "./ArtisanMsgBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports